import {CameraPage} from './camera/camera'
import {GeolocationPage} from './geolocation/geolocation'
import {MapPage} from './map/map'
/*********
 * 标签中心，主页导航目标声明
 *
 * ***********/
export const TEST_INDEX = [
  CameraPage,
  MapPage,
  GeolocationPage
];



// WEBPACK FOOTER //
// ./src/pages/test/index.ts